import React from 'react';
import { AppRouter } from './Router';
import './index.css';

function App() {
  return <AppRouter />;
}

export default App;
